import { SET_BLOGS_STATE } from '../../constants/redux_types'

export function blogsStateReducer(
  state = {
    blogs: [],
    test: 'asd'
  },
  action
) {
  if (action.type == SET_BLOGS_STATE) {
    state = action.payload
  }
  return state
}
